import Button from "hardcover-ui/components/Button";

export default function TrackProgress({
  trackRead,
}: {
  trackRead: () => void;
}) {
  return (
    <div className="flex flex-col my-2 space-y-1">
      <Button onClick={trackRead} variant="tertiary" size="md">
        Track Progress for this Book
      </Button>
    </div>
  );
}
